import { history } from '../hooks/history';

export const updateQueryParam = (key: string, value?: string) => {
  const params = new URLSearchParams(history.location.search);

  if (value === undefined) {
    params.delete(key);
  } else {
    params.set(key, value);
  }

  history.push({
    pathname: history.location.pathname,
    search: params.toString()
  });
};
